import { toast } from 'react-toastify';
import { getNotificationRoute } from '../../app/routing/notificationRouter';
import { safeNotificationUrl } from './notificationData';

export const showSuccess = (message) => {
  toast.success(message);
};

export const showError = (message) => {
  toast.error(message);
};

export const showInfo = (message) => {
  toast.info(message);
};

export const showWarning = (message) => {
  toast.warning(message);
};

// Enhanced FCM notification handler
export const showFCMNotification = (payload, userRole, navigate) => {
  const { title, body, type = 'info', category = 'general', data = {} } = payload;
  
  const toastConfig = {
    position: "top-right",
    autoClose: 6000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    icon: "🔔",
    onClick: () => {
      // Handle click - navigate to appropriate route
      if (navigate && userRole) {
        const route = data.actionUrl ? safeNotificationUrl(data.actionUrl) : getNotificationRoute(category, data, userRole);
        navigate(route);
      }
    }
  };

  const content = (
    <div>
      <strong style={{ fontSize: '15px' }}>{title}</strong>
      <p style={{ margin: '5px 0 0 0', fontSize: '13px', opacity: 0.9 }}>
        {body}
      </p>
      <small style={{ 
        display: 'block', 
        marginTop: '8px', 
        color: '#667eea',
        fontWeight: 600 
      }}>
        Click to view →
      </small>
    </div>
  );

  // Show toast based on type
  switch (type) {
    case 'success':
      toast.success(content, toastConfig);
      break;
    case 'error':
      toast.error(content, toastConfig);
      break;
    case 'warning':
      toast.warning(content, toastConfig);
      break;
    default:
      toast.info(content, toastConfig);
  }

};